import { render } from "./RiSuggest.vue?vue&type=template&id=402aa172"
import script from "./RiSuggest.vue?vue&type=script&lang=js"
export * from "./RiSuggest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiSuggest.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "402aa172"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('402aa172', __exports__)) {
    api.reload('402aa172', __exports__)
  }
  
  module.hot.accept("./RiSuggest.vue?vue&type=template&id=402aa172", () => {
    api.rerender('402aa172', render)
  })

}


export default __exports__